import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { API } from '../config/api';
import { GOOGLEMAP_KEY, ERROR } from '../../../@shared/constants'
import { tap, catchError } from 'rxjs/operators';
import { BoToastrService } from 'src/@core/shared';
import { ToastrService } from 'ngx-toastr';

declare const google: any;
@Injectable()
export class GoogleMapService {
    constructor(
        private _http: HttpClient,
        private _toastr: ToastrService
    ) { }
    public callGeoApi(request: any): Observable<any> {
        const apiUrl = API.GOOGLE_MAP.CALLGEOAPI(request, GOOGLEMAP_KEY);
        return this._http.get(encodeURI(apiUrl));
    }

    public calculateDistanceBetweenPostcodes(collectionPostCode: string, deliveryPostCode: string): Promise<number> {
        return new Promise((resolve, reject) => {
            if (!collectionPostCode || !deliveryPostCode) {
                this._toastr.error('Please enter two postcode\'s to calculate', 'Error', {
                    timeOut: 2000,
                    toastClass: 'toast toast-default-font'
                });
                return reject('Invalid arguments');
            }
            const distanceRequest = {
                origins: [collectionPostCode],
                destinations: [deliveryPostCode],
              travelMode: 'DRIVING',
              //Modified By: Babu
              ///Modified On: 21 - Sep - 2020
              //Issue: https://transive.atlassian.net/browse/ASAPSUP-29
              //Description: Google Routing Issue
              drivingOptions: {
                departureTime: new Date(Date.now()),  
                trafficModel: 'pessimistic'
              },
                unitSystem: google.maps.UnitSystem.IMPERIAL,
            };
            new google.maps.DistanceMatrixService().getDistanceMatrix(distanceRequest, (data) => {
                let distanceInMeter = 0;
                if (data['rows'][0]['elements'][0]['distance']) {
                    distanceInMeter = data['rows'][0]['elements'][0]['distance'].value || 0;
                } else {
                    distanceInMeter = 0;
                }

                resolve(Math.ceil(distanceInMeter / 1609.344));
            });
        });
    }

}
